export default __webpack_public_path__ + "static/media/Ryah.6f561055.jpg";